import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/round creams/round pineapple biscuit.png";
import BiscuitImg from "../../../assets/products/round creams/Round-Pineapple.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 13,
  },
  {
    grams: 18,
  },
  {
    grams: 20,
  },
  {
    grams: 30,
  },
  {
    grams: 40,
  },
  {
    grams: 50,
  },
  {
    grams: 70,
  },
  {
    grams: 90,
  },
];

export default function PineappleRoundProduct() {
  return (
    <>
      <Helmet>
        <title>
          Round Pineapple Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Round Pineapple Cream Biscuits — tropical pineapple-flavored sandwich biscuits with smooth cream filling. View pack sizes, cartons, and specs."
        />
        <meta
          name="keywords"
          content="Round Pineapple Cream Biscuit, BearBitz Pineapple Cream Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/round-cream-biscuit/round-pineapple"
        />
        <meta
          property="og:title"
          content="Round Pineapple Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Cream-filled pineapple sandwich biscuit in round shape with export-ready packaging."
        />
      </Helmet>

      <ProductTemplate
        productTitle="PINEAPPLE"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in every shape and flavor. A global snack sensation that delights with every bite."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#FFC100"
        sectionBgColor="#FFEFC2"
        productBgcolor="#FFE183"
        tableheadBgcolor="#FFC100"
        tableBgcolor="#FFF9E7"
        footerBgcolor="#FFC100"
      />
    </>
  );
}
